"use client";
import { ExploreMainBody, Header } from "@src/component";
import ExploreSEO from "@src/SEO/Explore.seo";

const Explore = () => {
    return (
        <>
            <ExploreSEO />
            <Header />
            <ExploreMainBody />
        </>
    );
};

export default Explore;